import { CalendarRange, ChevronDown } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from '../ui/dropdown-menu';

export default function SeasonStrip({ data, isAdmin, onManage, onPick }) {
  const { season, seasons = [], progress, active_season: active } = data;
  const pct = progress?.sessions_left != null && season?.target_sessions
    ? Math.min(100, Math.round(100 * progress.sessions_played / season.target_sessions))
    : null;

  let sub = '';
  if (season) {
    const bits = [];
    if (progress?.sessions_played != null) bits.push(`${progress.sessions_played} session${progress.sessions_played === 1 ? '' : 's'} played`);
    if (progress?.sessions_left != null) bits.push(`${progress.sessions_left} left`);
    if (progress?.days_left != null) bits.push(progress.days_left >= 0 ? `${progress.days_left}d left` : `ended ${-progress.days_left}d ago`);
    if (season.status === 'ended') bits.push('ended');
    sub = bits.join(' · ');
  } else {
    sub = active ? 'Showing all-time ratings' : 'No season running — all-time ratings';
  }

  return (
    <div className="rounded-2xl border bg-card px-4 py-3 flex items-center gap-3" data-testid="season-strip">
      <CalendarRange className="w-4 h-4 text-amber-600 dark:text-amber-300 shrink-0" />
      <div className="flex-1 min-w-0">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="font-bold text-sm inline-flex items-center gap-1 truncate max-w-full" data-testid="season-picker">
              {season ? season.name : 'All-time'} <ChevronDown className="w-3.5 h-3.5 shrink-0" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start">
            <DropdownMenuItem onClick={() => onPick('all')} data-testid="season-pick-all">All-time</DropdownMenuItem>
            {seasons.map((s) => (
              <DropdownMenuItem key={s.id} onClick={() => onPick(s.id)} data-testid={`season-pick-${s.id}`}>
                {s.name} {s.status === 'active' ? '· live' : ''}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
        <p className="text-xs text-muted-foreground truncate" data-testid="season-sub">{sub}</p>
        {pct != null && (
          <div className="mt-1.5 h-1 rounded-full bg-muted overflow-hidden">
            <div className="h-full bg-amber-500 transition-[width] duration-500" style={{ width: `${pct}%` }} />
          </div>
        )}
      </div>
      {isAdmin && (
        <Button size="sm" variant={active ? 'outline' : 'default'} className="rounded-full h-8 text-xs shrink-0" onClick={onManage} data-testid="season-manage-btn">
          {active ? 'Seasons' : 'Start season'}
        </Button>
      )}
    </div>
  );
}
